export default __webpack_public_path__ + "static/media/agents.4aa8c447.webp";